// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fy3U","top":"styles_top__34cyt","left":"styles_left__9cI7X","description":"styles_description__2x-rZ"};